import { render, staticRenderFns } from "./TextWidget.vue?vue&type=template&id=e2252c82&scoped=true"
import script from "./TextWidget.vue?vue&type=script&lang=js"
export * from "./TextWidget.vue?vue&type=script&lang=js"
import style0 from "./TextWidget.vue?vue&type=style&index=0&id=e2252c82&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2252c82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2252c82')) {
      api.createRecord('e2252c82', component.options)
    } else {
      api.reload('e2252c82', component.options)
    }
    module.hot.accept("./TextWidget.vue?vue&type=template&id=e2252c82&scoped=true", function () {
      api.rerender('e2252c82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/designer/widgets/TextWidget.vue"
export default component.exports